import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

// Configurar token de Mapbox
mapboxgl.accessToken = 'pk.eyJ1Ijoid2lsc29za2kyOSIsImEiOiJjbWVsc2d1Mnkwa3YzMmxwemttdHhvdXNwIn0.vbKrL2I77eNpKMAFHw4TFQ';

const MapaUbicacion = ({ ubicacion, dispositivoNombre, onCerrar }) => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);

  useEffect(() => {
    if (!mapContainer.current || map.current) return;

    // Crear el mapa
    map.current = new mapboxgl.Map({
      container: mapContainer.current,
      style: 'mapbox://styles/mapbox/streets-v11',
      center: [parseFloat(ubicacion.lng), parseFloat(ubicacion.lat)],
      zoom: 15,
      attributionControl: false
    });

    // Agregar controles de navegación
    map.current.addControl(new mapboxgl.NavigationControl(), 'top-right');
    map.current.addControl(new mapboxgl.FullscreenControl(), 'top-right');

    // Agregar marcador de ubicación
    new mapboxgl.Marker({
      color: '#4F49F0',
      scale: 1.2
    })
      .setLngLat([parseFloat(ubicacion.lng), parseFloat(ubicacion.lat)])
      .addTo(map.current);

    // Agregar popup con información
    new mapboxgl.Popup({
      closeButton: false,
      closeOnClick: false,
      className: 'mapa-popup'
    })
      .setLngLat([parseFloat(ubicacion.lng), parseFloat(ubicacion.lat)])
      .setHTML(`
        <div class="popup-content">
          <h3 class="popup-title">${dispositivoNombre}</h3>
          <p class="popup-location">Ubicación actual</p>
          <div class="popup-coords">
            <span>Lat: ${parseFloat(ubicacion.lat).toFixed(6)}</span><br>
            <span>Lng: ${parseFloat(ubicacion.lng).toFixed(6)}</span>
          </div>
        </div>
      `)
      .addTo(map.current);

    // Evento cuando el mapa se carga
    map.current.on('load', () => {
      setMapLoaded(true);
    });

    // Limpiar al desmontar
    return () => {
      if (map.current) {
        map.current.remove();
        map.current = null;
      }
    };
  }, [ubicacion, dispositivoNombre]);

  // Actualizar centro del mapa si cambia la ubicación
  useEffect(() => {
    if (map.current && mapLoaded) {
      map.current.flyTo({
        center: [parseFloat(ubicacion.lng), parseFloat(ubicacion.lat)],
        zoom: 15,
        duration: 2000
      });
    }
  }, [ubicacion, mapLoaded]);

  return (
    <div className="w-full h-96 relative">
      {/* Contenedor del mapa */}
      <div 
        ref={mapContainer} 
        className="w-full h-full rounded-lg overflow-hidden"
        style={{ fontFamily: 'Montserrat, sans-serif' }}
      />
      
      {/* Indicador de carga */}
      {!mapLoaded && (
        <div className="absolute inset-0 bg-gray-100 flex items-center justify-center rounded-lg">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-2"></div>
            <p className="text-gray-600 text-sm">Cargando mapa...</p>
          </div>
        </div>
      )}
      
      {/* Estilos personalizados para el popup */}
      <style jsx>{`
        .mapa-popup .mapboxgl-popup-content {
          background: white;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          border: none;
          padding: 12px;
          font-family: 'Montserrat', sans-serif;
        }
        
        .mapa-popup .mapboxgl-popup-tip {
          border-top-color: white;
        }
        
        .popup-content {
          text-align: center;
        }
        
        .popup-title {
          color: #4F49F0;
          font-weight: 600;
          font-size: 14px;
          margin: 0 0 4px 0;
        }
        
        .popup-location {
          color: #6B7280;
          font-size: 12px;
          margin: 0 0 8px 0;
        }
        
        .popup-coords {
          color: #374151;
          font-size: 11px;
          font-family: 'Monaco', 'Menlo', monospace;
          background: #F3F4F6;
          padding: 4px 8px;
          border-radius: 4px;
        }
      `}</style>
    </div>
  );
};

export default MapaUbicacion;
